import { Checkbox } from "components/inputs";
import type { DocumentType } from "../../DocumentTypes";
import type { DocumentTableDataType } from "../../DocumentTableTypes";

type Props = {
  row: DocumentTableDataType;
  onChange: (doc: DocumentType) => void;
  isUpdating: boolean;
};

export const CmsCheckboxCell = ({ row, onChange, isUpdating }: Props) => (
  <div className="flex jc-c">
    <Checkbox
      name={`cms-doc-${row.id}`}
      label=""
      checked={row.is_cms_submission_document}
      onChange={() => onChange(row.document)}
      readOnly={isUpdating}
    />
  </div>
);
